export const pageSizeSelectTestIds = {
  container: 'page-size-container',
  select: 'document-settings-page-size-select',
};
